import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "最新更新", to: "/latest" },
  { label: "人气榜单", to: "/ranking" },
  { label: "常见问题", to: "/faq" },
  { label: "关于我们", to: "/about" },
];

const genreLinks = ["热血", "奇幻", "科幻", "恋爱", "悬疑", "国漫", "日漫"];

export default function MangaFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-book-open-fill"></i>
              </span>
              <span className="font-heading text-xl text-background-50">天天漫画网</span>
            </div>
            <p className="mt-4 text-sm leading-6 text-background-300">
              每日更新海量人气连载漫画，今日最新话抢先看。追更不迷路，热门日漫、国漫持续上线，打开即享最新剧情。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">快速导航</h4>
            <ul className="space-y-3 text-sm text-background-300">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="hover:text-accent-300 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">热门分类</h4>
            <ul className="space-y-3 text-sm text-background-300">
              {genreLinks.map((g) => (
                <li key={g}>
                  <Link to="/latest" className="hover:text-accent-300 transition-colors">
                    {g}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4">更新时段</h4>
            <p className="text-sm text-background-300 leading-6">
              每日 08:00 - 18:00 陆续上线最新话。
              <br />
              热门国漫周更 / 隔日更，
              <br />
              热门日漫按原版节奏更新。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="mailto:contact@tiantian-manhua.example.com"
                className="text-sm text-background-300 hover:text-accent-300 transition-colors"
              >
                contact@tiantian-manhua.example.com
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-800/60">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2026 天天漫画网 版权所有</p>
          <p className="flex items-center gap-1">
            <i className="ri-time-line"></i>今日已更新 120+ 话连载，持续为你追更
          </p>
        </div>
      </div>
    </footer>
  );
}